import { render } from "./FormFile.vue?vue&type=template&id=3f828684"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"
script.render = render

export default script